import { Platform } from './Platform';
import { MessageOverrideKey } from './MessageOverrideKey';
import { Step } from '../views/Step';
import { MessageKey } from './MessageKey';
const ElevateOverride = new Map([[MessageOverrideKey.Elevate, new Map([[Step.LandingPage, MessageKey.HubSpotElevate]])]]);
const StrategicPartnerOverride = new Map([[MessageOverrideKey.StrategicPartner, new Map([[Step.LandingPage, MessageKey.HubSpotStrategicPartner]])]]);
const DesktopMessaging = new Map([...Array.from(ElevateOverride), ...Array.from(StrategicPartnerOverride)]);
const MobileMessaging = new Map([...Array.from(ElevateOverride), ...Array.from(StrategicPartnerOverride)]);
export const MessageOverideConfig = {
  [Platform.Desktop]: DesktopMessaging,
  [Platform.Mobile]: MobileMessaging
};